import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-multi-card-slider',
  templateUrl: './multi-card-slider.component.html',
  styleUrls: ['./multi-card-slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiCardSliderComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('owlCar', { static: false }) owlCar: any;
  // filterSliderData: any = [];
  sliderData: any = [
    {
      id: 0,
      name: '1872',
      text: 'The China Navigation Company (CNCo) commenced operations on the Yangtze River, operating Mississippi-style paddles steamers.',
      image: '../../assets/media/year-img/1872.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/popup-img/1872.jpg',
      showBtn: true
    },
    {
      id: 1,
      name: '1873',
      text: 'Tunsin became the first vessel to sail under the CNCo flag. In the same year, CNCo built its first ship, s.s. Pekin, a paddle steamer for service on the lower Yangtze.',
      image: '../../assets/media/year-img/1873.jpg',
      popupText: 'Tunsin was built in the USA in 1863, the hull by J. D. Samuda with engines from J. Penn & Sons. Its name was the hong name of earlier Shanghai Owners - Barnett & Co. In 1883 it was converted into a hulk, ending its days at Swatow early in the twentieth century.',
      popupImage: '../../assets/media/popup-img/1873.jpg',
      showBtn: true
    },
    {
      id: 2,
      name: '1882',
      text: 'After securing the lucrative soya bean and ‘beancake’ trade, CNCo became the most profitable company on the Yangtze River, doubling its annual net profit by this year.',
      image: '../../assets/media/year-img/1882.jpg',
      popupText: 'Within a decade, CNCo had expanded its operations up and down the China coast and had begun regular services to Australia and New Zealand. One of the company’s early successes was to take a monopoly of the previously junk-borne tramp trade in “beancake” which were carried from North to South China to use as a fertiliser. At the turn of the century, CNCo’s by then substantial fleet was covering a complex network of Far Eastern trades, backed up by its own well-established coastal and river feeder services.',
      popupImage: '../../assets/media/popup-img/1882.jpg',
      showBtn: true
    },
    {
      id: 3,
      name: '1886',
      text: 'CNCo started a liner service to Japan carrying Tai-Koo Sugar northbound from Hong Kong and lifting rice for Australia.',
      image: '../../assets/media/year-img/1886.jpg',
      popupText: 'The construction of the Taikoo Dockyard in Hong Kong literally entailed moving a mountain: 1,600,000 cubic yards of granite hillside was levelled and used to reclaim 20 acres from the harbour at Quarry Bay, creating a total flat area of more than 52 acres and over half a mile of deep-water berths. Boasting Hong Kong’s largest supply of electrical power, its most extensive machine shops and a dry-dock capable of accommodating the largest ships in the world, Taikoo would go on to become one of Hong Kong\'s biggest, and one of its most progressive employers.',
      popupImage: '../../assets/media/popup-img/1886.jpg',
      showBtn: true
    },
    {
      id: 4,
      name: '1920',
      text: 'Under the stewardship of John Samuel Swire\'s two sons, the 1920s sees the CNCo fleet reaching a peak of more than 80 vessels.',
      image: '../../assets/media/year-img/1920.jpg',
      popupText: 'This period saw considerable expansion of Swire\'s marine business under the Chairmanship of John Samuel Swire\'s two sons, John - known as "Jack" (1861-1933), who took over following the death of James Henry Scott in 1912, and (George) Warren Swire (1883-1949), who became Chairman in 1927',
      popupImage: '../../assets/media/popup-img/1920.jpg',
      showBtn: true
    },
    {
      id: 5,
      name: '1942',
      text: 'World War II very nearly destroyed Swire.',
      image: '../../assets/media/year-img/1942.jpg',
      popupText: 'The Yangtze River was closed to foreign shipping from 1942 and increasing restrictions on shipping on the China coast foreshadowed the firm’s gradual withdrawal from the Chinese mainland. By 1945, the Taikoo Sugar Refinery and Taikoo Dockyard had been reduced to rubble during bombing raids on Hong Kong, more than 30 China Navigation vessels had been captured or sunk, and company properties throughout the region had been destroyed or looted.',
      popupImage: '../../assets/media/popup-img/1942.jpg',
      showBtn: true
    },
    {
      id: 6,
      name: '1946',
      text: 'Swire rebuilds after the second war. CNCo pioneered new trading routes from Australia to Papua New Guinea and the Pacific Islands',
      image: '../../assets/media/year-img/1946.jpg',
      popupText: 'Jack Swire\'s son, John Kidston Swire (1893-1983), known as “Jock”, became Chairman of Swire. Under his leadership, Swire rebuilt its key operational businesses. By 1950, Taikoo Sugar and Taikoo Dockyard were back in full production. With Hong Kong as its home port, China Navigation began to establish new services to Australia, New Zealand and Papua New Guinea. Its growing network of Pacific Rim services established the pattern for the liner trades in which the company participates to this day.',
      popupImage: '../../assets/media/popup-img/1946.jpg',
      showBtn: true
    },
    {
      id: 7,
      name: '1960',
      text: 'In the 1960s and ‘70s, CNCo introduced the revolutionary containerised method of carrying cargo in the Pacific using self-geared vessels with mobile gantry cranes.',
      image: '../../assets/media/year-img/1960.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/year-img/1960.jpg',
      showBtn: false
    },
    {
      id: 8,
      name: '1975',
      text: 'Prince Tomohito of Japan travelled on CNCo\'s Coral Princess to celebrate the vessel\'s 100th journey from Japan since her inauguration in July 1971.',
      image: '../../assets/media/year-img/1975.jpg',
      popupText: 'In that time the Coral Princesss carried more than 40,000 passengers.',
      popupImage: '../../assets/media/popup-img/1975.jpg',
      showBtn: true
    },
    {
      id: 9,
      name: '1981',
      text: 'CNCO\'s Lindblad Explorer was the first tourist ship to cross the South Magnetic Pole.',
      image: '../../assets/media/year-img/1981.jpg',
      popupText: 'The Linblad Exporer was an ice-strengthened vessel jointly owned by CNCo and Lindblad Travel.',
      popupImage: '../../assets/media/popup-img/1981.jpg',
      showBtn: true
    },
    {
      id: 10,
      name: '1997',
      text: 'Margaret Pidgeon, Master of Chengtu, is appointed as CNCO\'s first female ship captain.',
      image: '../../assets/media/year-img/1997.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/year-img/1997.jpg',
      showBtn: false
    },
    {
      id: 11,
      name: '2008',
      text: 'CNCo formed Swire CTM Bulk Logistics - a 50/50 joint venture with Monaco-based C Transport Maritime (CTM).',
      image: '../../assets/media/year-img/2008.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/popup-img/2019.jpg',
      showBtn: false
    },
    {
      id: 12,
      name: '2010',
      text: 'CNCo moved its headquarters from Hong Kong to Singapore.',
      image: '../../assets/media/year-img/2010.jpg',
      popupText: 'The new office was officially opened on 8 March by Mrs Lim Hwee Hua, Singapore\'s Minister in the Prime Minister\'s Office and 2nd Minister for Finance and Transport. ',
      popupImage: '../../assets/media/popup-img/2010.jpg',
      showBtn: true
    },
    {
      id: 13,
      name: '2018',
      text: '(CNCo) opened its China headquarters officially in Shanghai on 05 November 2018, marking a significant return to its birthplace 147 years ago.',
      image: '../../assets/media/year-img/2018.jpg',
      popupText: 'CNCo welcomes its first batch of female cadets from Papua New Guinea (PNG) in October 2018 as part of its efforts to develop local talent. On 28 October 2018, the deck cadets joined their first deep sea vessel, MV Szechuen, at Port Moresby.',
      popupImage: '../../assets/media/popup-img/2018.jpg',
      showBtn: true
    },
    {
      id: 14,
      name: '2019',
      text: 'China Navigation aquired the bulk shipping activities of Hamburg Süd.',
      image: '../../assets/media/year-img/2008.jpg',
      popupText: 'The acquisition included Rudolf A. Oetker (RAO), Furness Withy Chartering and the bulk activities in Alianca Navegacão (Aliabulk). The bulk shipping business in Hamburg Süd included a chartered fleet of approximately 45 vessels including: Handysize, Supra/Ultramax and Kamsarmax/Panamax.',
      popupImage: '../../assets/media/popup-img/2019.jpg',
      showBtn: true
    },
    {
      id: 15,
      name: '2020',
      text: 'Swire Projects was created as a division of Swire Shipping to provide specialist shipping services to the energy, resource, and infrastructure sectors.',
      image: '../../assets/media/year-img/2008.jpg',
      popupText: 'Swire Shipping launched new integrated logistics services to complement its traditional port-to-port services, helping to simplify customers\' supply chains',
      popupImage: '../../assets/media/popup-img/2019.jpg',
      showBtn: true
    },
    {
      id: 16,
      name: '2021',
      text: 'CNCo formally became Swire Shipping Pte Ltd. Swire Bulk separated from CNCo to become an independent entity.',
      image: '../../assets/media/year-img/2008.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/popup-img/2019.jpg',
      showBtn: false
    },
    {
      id: 17,
      name: '2022',
      text: 'CNCo celebrates it\'s 150th anniversary - celebrating our heritage and navigating our future as Swire Shipping.',
      image: '../../assets/media/year-img/2022.jpg',
      popupText: 'The China Navigation Company’s parent company, John Swire & Sons Limited, has its origins in a small Liverpool trading house founded in 1816. In 1866, John Samuel Swire (1825-1898) opened his first Far Eastern agency in Shanghai, and in 1872 he founded The China Navigation Company where it operated Mississippi-style paddle-steamers on China’s Yangtze River.',
      popupImage: '../../assets/media/year-img/2022.jpg',
      showBtn: false
    },
  ];
  customOptions: OwlOptions = {
    // autoplay: false,
    // center: true,
    startPosition: 0,
    margin: 40,
    dots: true,
    lazyLoad: false,
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    navSpeed: 700,
    navText: ["<img src='../../assets/media/leftIcon.svg'>", "<img src='../../assets/media/rightArrow.svg'>"],
    nav: true,
    center: true,
    responsive: {
      0: {
        items: 1,
        dots: false,
      },
      400: {
        items: 2,
        dots: false,
      },
      760: {
        items: 3.4
      },
      1000: {
        items: 3.4
      }
    },

  }
  popupData: any = [];
  activeTab: string = '';
  leftBtnDisable: boolean = false;
  rightBtnDisable: boolean = false;
  activeSlides!: SlidesOutputData;
  removeDefaultNav = true;
  getPassedData(data: SlidesOutputData) {
    this.activeSlides = data;
    if (this.activeSlides?.slides) {
      if (!this.clickedTab) {
        this.checkActiveSlides(this.activeSlides?.slides[0]?.id);
      }
    }
  }
  clickedTab = false;
  extraForPopupData: any = [
    {
      id: 2,
      name: '1872',
      text: 'The China Navigation Company (CNCo) commenced operations on the Yangtze River, operating Mississippi-style paddles steamers.',
      image: '../../assets/media/year-img/1872.jpg',
      popupText: 'At the time when The China Navigation Company (CNCo) was established, its major competitor on the Yangtze River was an American-owned business, the Shanghai Steam Navigation Company. John Samuel Swire was determined to outdo his rivals and the flag he designed for his new shipping company was deliberately provocative. Shanghai Steam Navigation’s flag showed two blue triangles, apex to apex, on a white ground; CNCo’s was to be identical - but red instead of blue. However, at the last minute, John Samuel Swire introduced a wide blue vertical stripe through the centre of the flag where the two triangles met, and the Swire flag was born.',
      popupImage: '../../assets/media/popup-img/1872-2.jpg',

    },
    {
      id: 3,
      name: '1872',
      text: 'The China Navigation Company (CNCo) commenced operations on the Yangtze River, operating Mississippi-style paddles steamers.',
      image: '../../assets/media/year-img/1872.jpg',
      popupText: '',
      popupImage: '../../assets/media/popup-img/1872-3.jpg',

    },
    {
      id: 5,
      name: '1920',
      text: 'The China Navigation Company (CNCo) commenced operations on the Yangtze River, operating Mississippi-style paddles steamers.',
      image: '../../assets/media/year-img/1872.jpg',
      popupText: '',
      popupImage: '../../assets/media/popup-img/1920-2.jpg',
      showBtn: true
    },
  ];

  popupDataIndex = 0;
  constructor(
    private _cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.owlCar?.to("owl-slide-" + 2);
  }
  ngAfterViewInit(): void {
    this.filterSlider('late', 1800);
    this.removeDefaultNav = true;
  }
  ngAfterViewChecked() {
    this._cdRef.detectChanges();
  }
  readMore(name: any) {
    this.popupData.length = 0;
    this.popupDataIndex = 0;
    let index = this.sliderData.findIndex((data: any) => data?.name == name);
    if (index >= 0) {
      this.popupData.push(this.sliderData[index]);
      this.extraForPopupData.forEach((element: any) => {
        if (element?.name == this.sliderData[index]?.name) {
          this.popupData?.push(element);
        }
      });
    }
  }
  filterSlider(period: string, val: any) {
    this.removeDefaultNav = false;
    this.clickedTab = true;
    val = Number(val);
    this.activeTab = val + period;
    let index = null;
    switch (period) {
      case 'early':
        index = this.sliderData.findIndex((el: any) => (el?.name > val) && (el?.name < val + 72));
        if (index >= 0) {
          if (window?.innerWidth >= 1024) {
            if (this.activeTab == '2000early') {
              index += 1;
            }
          }
          let ids = this.sliderData[index]['id'] + '';
          this.owlCar?.to("owl-slide-" + index);
        }
        break;
      case 'late':
        if (window?.innerWidth < 1024) {
          index = this.sliderData.findIndex((el: any) => (el?.name > val + 71) && (el?.name < val + 99));
        } else {
          index = this.sliderData.findIndex((el: any) => (el?.name > val + 72) && (el?.name < val + 99));
        }

        if (index >= 0) {
          if (window?.innerWidth >= 1024) {
            if (this.activeTab == '1900late') {
              index += 1;
            }
          }
          let ids = this.sliderData[index]['id'] + '';
          // this.owlCar?.to(ids);
          if(index == 0 && window?.innerWidth > 500){
            index+=1;
          }
          this.owlCar?.to("owl-slide-" + index);
        }
        break;
      default:
        break;
    }
    setTimeout(() => {
      this.clickedTab = false;
    }, 0);

  }

  leftPopUpDetail(popupBtnName: any) {
    this.leftBtnDisable = false;
    this.rightBtnDisable = false;
    if (popupBtnName == 'left' && this.popupDataIndex > 0) {
      this.popupDataIndex--;
    } else if (popupBtnName == 'right' && this.popupDataIndex < (this.popupData?.length - 1)) {
      this.popupDataIndex++;
    } else if (popupBtnName == 'left' && this.popupDataIndex == 0) {
      this.leftBtnDisable = true;
    } else if (popupBtnName == 'right' && this.popupDataIndex == (this.popupData?.length - 1)) {
      this.rightBtnDisable = true;
    }
  }
  private checkActiveSlides(item: any) {
    if (item) {
      this.removeDefaultNav = false;
      let index = this.sliderData.find((el: any) => (el?.id == item));
      if (index?.name >= 1870 && index?.name < 1900) {
        this.activeTab = '1800late';
      } else if (index?.name >= 1920 && index?.name < 1969) {
        this.activeTab = '1920early';
      }
      else if (index?.name >= 1970 && index?.name < 2000) {
        this.activeTab = '1900late';
      }
      else if (index?.name >= 2000 && index?.name < 2040) {
        this.activeTab = '2000early';
      }
    }

  }
}
